<template>
    <div id="page">

        <div class="page-content" style="min-height:400px">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>کارتابل درخواست ها <button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button></h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>

            <div class="card card-style mb-2">
                <div class="row m-0 p-3">
                    <div class="col-6 pr-0 pl-1">
                        <div class="input-style input-style-2 input-required has-icon mb-0">
                            <i class="input-icon fa fa-filter color-orange-dark"></i>
                            <em><i class="fa fa-angle-down"></i></em>
                            <select class="form-control" v-model="filterId" autocomplete="off" @change="filterList">
                                <option value="0">جاری</option>
                                <option value="1">بدون اقدام ها</option>
                                <option value="2">درحال بررسی</option>
                                <option value="3">تایید شده</option>
                                <option value="4">رد شده</option>
                                <option value="5">همه</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-6 p-0">
                        <div v-if="showApplicantUser" class="btn-group btn-group-sm w-100">
                            <v-select class="w-100" dir="rtl" label="title" v-on:input="filterList" placeholder="درخواست کننده" :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListList" :reduce="p => p.userId" v-model="applicantUserId">
                                <template slot="option">
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>
                </div>  
            </div>
            <div class="card card-style mb-2" v-for="task in TaskCloseList" :key="task.closeRequestId" @click.prevent="openDetails(task.closeRequestId)">
                <div class="list-group list-custom-small list-icon-0">
                    <div class="list-group-div p-2">
                        <div class="d-flex justify-content-between">
                            <div>
                                <i class="fa fa-hashtag color-blue2-dark"></i>
                                <span class="text-muted">{{task.taskNo}}</span>
                            </div>
                            <div>
                                <i class="fa fa-calendar text-warning"></i>
                                <span class="text-muted text-left ltr d-inline-block">{{task.strRequestDateTime}}</span>
                            </div>
                            <div>
                                <span class="badge font-10 position-static mt-0" :id="'userActionTitleSpan-'+task.closeRequestId" :class="getClassNameForUserActionTitleSpan(task.closeRequestId,task.userActionTitle)">{{task.userActionTitle}}</span>
                            </div>
                        </div>
                        <div>
                            <i class="fa fa-check color-red1-dark"></i>
                            <span class="font-weight-bold">{{task.taskFolderTitle}}</span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>
                                <i class="fa fa-user-plus color-green2-light"></i>
                                <span class="text-muted">{{task.userTitle}}</span>
                            </div>
                            <div>
                                <i class="fa fa-user-check color-pink2-dark"></i>
                                <span class="text-muted">{{task.toUserTitle}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="Loading==false && NoMoreData==false && TaskCloseList.length>0">
                <div class="content">
                    <div class="d-flex justify-content-center w-100">
                        <button class="btn btn-outline-info" @click="getNextPageForTaskCloseList">نمایش بیشتر</button>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="Loading">
                <div class="content">
                    <div class="d-flex justify-content-center w-100 py-5">
                        <div class="spinner-border color-magenta2-dark" role="status"></div>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="TaskCloseList.length==0 && Loading==false">
                <div class="content">
                    <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                    <p class="text-center py-3">درخواستی یافت نشد.</p>
                </div>
            </div>
        </div>



        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">

                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'CloseTask', params: { closeRequestId: selectedRequestId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <router-link :to="{ name: 'TaskWorkList', params: { taskFolderId: selectedTaskFolderId,taskId:selectedTaskId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-check-square color-blue2-light float-right font-14"></i>لیست پیگیری ها</span><i class="fa fa-angle-left"></i></router-link>

                </div>
                <div class="clear"></div>
            </div>
        </div>

        <Help-Menu title="راهنمای کارتابل درخواست ها" keyEn="TaskCloseRequest"></Help-Menu>
        <!--<div id="taskCloseHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">راهنمای کارتابل درخواست ها</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-CloseTask.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-CloseTask.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-1" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa fa-folder-open color-orange-dark font-14"></i>
                                <span class="font-14">راهنمای کارتابل درخواست ها </span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-1" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video1" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/close-task.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/close-task.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>



</template>

<script>
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                applicantUserId: null,
                selectedTaskFolderId: 0,
                selectedTaskId: 0,
                selectedRequestId: 0,
                showApplicantUser:false
            };
        },
        watch: {
            'applicantUserId': function (val) {
                this.$store.dispatch("GetTaskCloseRequestListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    applicantUserId: this.applicantUserId
                });
            }
        },
        computed: {
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },
            TaskCloseList() {
                return this.$store.getters.GetTaskCloseRequestList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetTaskCloseNoMoreData;
            }
        },

        created() {
            this.getUserList();
        },
        methods: {
            showMenu(taskFolderId, taskId,requestId) {
                this.selectedTaskFolderId = taskFolderId;
                this.selectedTaskId = taskId;
                this.selectedRequestId = requestId
            },
            getUserList() {
                this.$store.dispatch("GetLocalUserListListFromServer", {}).then(x => {
                    this.$http.get("Account/GetLogginedUserID")
                        .then(data => {
                            this.applicantUserId = data.data;
                            this.showApplicantUser = true;
                        });
                });
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetTaskCloseRequestListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    applicantUserId: this.applicantUserId
                });
            },
            openDetails(requestId) {
                this.$router.push({ name: 'CloseTask', params: { closeRequestId: requestId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForTaskCloseList() {
                this.page++;
                console.log(this.page);
                this.$store.dispatch("GetTaskCloseRequestListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    applicantUserId: this.applicantUserId
                });
            },
			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
            },
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
			getClassNameForUserActionTitleSpan(closeRequestId, userActionTitle) {
				var classNsme = "";
				userActionTitle = userActionTitle.trim();
				switch (userActionTitle) {
					case "در حال بررسي":
						classNsme = "badge-primary";
						break;
					case "بدون اقدام":
						classNsme = "badge-warning text-white";
						break;

					default:
						classNsme = "badge-info";
				}
				return classNsme;
			}
        },
        mounted() {
            console.log("mounted");

          //  this.getNextPageForTaskCloseList();
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },
		
    };</script>
